import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const SideTitle = ({ first, last, className = "" }) => {
    if (!className.includes("font-")) {
        className += ` font-big`;
    }
    const { language } = useLanguage();
    return (
        <div
            className={`font-w-bold ${
                language !== "ar" && "text-left"
            } clr-text-primary ${className}`}
        >
            <div className="relative">
                <span className="">
                    <span className="clr-text-primary smooth">{first} </span>
                    <span className="text-germanRed-700 dark:text-germanRed-400 smooth">
                        {last}{" "}
                    </span>
                </span>
                <span
                    className={`absolute w-28 h-1 bg-secondary-container rounded-md ${
                        language !== "ar" ? "left-0" : "right-0"
                    }  top-full smooth`}
                ></span>
                <span
                    className={`absolute w-14 h-1 bg-secondary-container rounded-md ${
                        language !== "ar" ? "left-0" : "right-0"
                    } top-full transform translate-y-2 smooth`}
                ></span>
                <span
                    className={`absolute w-14 h-1 bg-secondary-container rounded-md ${
                        language !== "ar" ? "left-0" : "right-0"
                    } bottom-full transform -translate-y-2 smooth`}
                ></span>
            </div>
        </div>
    );
};

export default SideTitle;
